import React from "react";

import { Tag } from "@components";
import { useBasePath } from "@hooks";

import { RuleFromYaml, RuleType } from "../../types";

const getFilteredTagsFromRuleId = (
  possibleTags: string[],
  simpleName: string,
  languages: string[]
) => {
  /* Show categories from very.long.rule.id as tags, filtering out
  information that is shown elsewhere, like languages and the simpleName.
  Also filter out meaningless tags like "lang" that mostly mean "general" */
  return possibleTags.filter((candidate) => {
    return (
      !simpleName.includes(candidate) &&
      candidate !== "lang" &&
      !languages.includes(candidate)
    );
  });
};

export const RuleNameCell: React.FC<{
  rule: RuleFromYaml;
  ruleType: RuleType;
}> = ({ rule, ruleType }) => {
  // Ruleset is the ruleset name if the type is rulesetRule,
  // or the saved rule name (user:ruleTitle) if type is savedRule
  const basePath = useBasePath();
  const ruleset = rule.metadata?.["semgrep.ruleset"]?.toLowerCase();
  const ruleIdParts = rule.id.split(".");
  const simpleRuleName = ruleIdParts[ruleIdParts.length - 1];
  const tags = getFilteredTagsFromRuleId(
    ruleIdParts,
    simpleRuleName,
    rule.languages
  );
  const snippetId = rule.metadata!["semgrep.url"]!.slice(-4);
  let ruleLink = "";
  if (ruleType === "savedRule") {
    ruleLink = `${basePath}/editor/s/${ruleset}`;
  } else if (ruleType === "snippet") {
    ruleLink = rule.metadata?.["semgrep.url"]!;
  } else {
    ruleLink = `${basePath}/editor/r/${rule.id}`;
  }

  return (
    <div>
      {ruleType === "rulesetRule" && (
        <>
          <a href={`/p/${ruleset}`}>{ruleset}</a>
          {" / "}
        </>
      )}
      <a href={ruleLink}>
        {ruleType === "savedRule" ? ruleset : simpleRuleName}
        {ruleType === "snippet" && ` (${snippetId})`}
      </a>{" "}
      {tags.map((tag, idx) => (
        <span key={idx}>
          <Tag minimal>{tag}</Tag>{" "}
        </span>
      ))}
    </div>
  );
};
